<template>
  <span class="bg-brand-red flex h-8 w-8 items-center justify-center rounded-full">
    <svg
      class="text-brand-white h-4 w-4"
      viewBox="0 0 20 20"
      fill="currentColor"
      aria-hidden="true">
      <path
        fill-rule="evenodd"
        d="M16.704 5.29a1 1 0 0 1 .006 1.414l-7.2 7.25a1 1 0 0 1-1.414.004L3.296
           9.19a1 1 0 1 1 1.408-1.42l3.09 3.063 6.495-6.54a1 1 0 0 1 1.415-.003Z"
        clip-rule="evenodd" />
    </svg>
  </span>
</template>
